import React, { useState, useContext } from "react";
import { useForm } from "react-hook-form";
import { AuthContext } from "../../context/AuthContext";
import "./ResetPassword.scss";
import masterApi from "../../services/masterApi";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const ResetPassword = ({closeResetPassword}) => {
  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
  } = useForm();
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [viewLoader, setViewLoader] = useState(false);
  const { handleLogout } = useContext(AuthContext);

  const onSubmit = async (data) => {
    //setViewLoader(true);
    try {
      const userData = await masterApi.resetPassword({ data });
      if (userData?.data?.ok) {
        toast.success("Password reset successfully. Please login again.", {
          autoClose: 1000, // 1 seconds
          onClose: () => {
            handleLogout();
            setSuccess("Success"); // Close after the toast ends
          }
        });
        
      } else {
        //setViewLoader(false);
        setError(userData?.error);
        toast.error(userData?.response?.data?.message);
      }
    } catch (error) {
      //setViewLoader(false);
      setError("Someting went wrong!");
      console.error("Login failed:", error.message);
    }
  };

  return (
    <div className="reset-password">
      <h2 className="heading space-between">Change Password</h2>
      {error && <div className="alert space-between">{error}</div>}
      {success && <div className="alert space-between">{success}</div>}

      <form
        className="reset-form"
        onSubmit={handleSubmit(onSubmit)}
      >
        <input
          {...register("oldpassword", { required: "Old Password is required" })}
          className={`input ${
            errors.oldpassword ? "form-control required" : "form-control"
          }`}
          type="password"
          placeholder="Old Password"
        />
        <input
          {...register("newpassword", { required: "New Password is required",
            pattern: {
              value: new RegExp(process.env.REACT_APP_PASSWORD_REGEX),
              message:
                "Password must be at least 8 characters long, contain at least one uppercase letter, one lowercase letter, one number, and one special character (!@#$&*)",
            }
           })}
          className={`input ${
            errors.newpassword ? "form-control required" : "form-control"
          }`}
          type="password"
          placeholder="New Password"
        />
        <input
          {...register("confirmpassword", {
            required: "Mismatched password",
            validate: {
              passwordEqual: (value) =>
                value === getValues().newpassword || "Mismatched password",
            },
          })}
          className={`input ${
            errors.confirmpassword ? "form-control required" : "form-control"
          }`}
          type="password"
          placeholder="Confirm Password"
        />
        {errors.newpassword && (
          <div className="redColor space-between">
            {errors.newpassword.message}
          </div>
        )}
        {errors.confirmpassword && (
          <div className="redColor space-between">
            {errors.confirmpassword.message}
          </div>
        )}
        <div className="action-btn">
          <button type="button" className="cancel secondary-btn" onClick={closeResetPassword}>Cancel</button>
          <button className="primary-btn" type="submit">
          {viewLoader && (
            <div className="loder-wrapper">
              <span className="loader-icon"></span>
            </div>
          )}
          Submit
        </button>
        </div>
      </form>
    </div>
  );
};

export default ResetPassword;
